import React from 'react';

import icon01 from "../../assets/security/reportIcon01.png";
import icon02 from "../../assets/security/reportIcon02.png";
import icon03 from "../../assets/security/reportIcon03.png";
import icon04 from "../../assets/security/reportIcon04.png";
import icon05 from "../../assets/security/reportIcon05.png";
import icon06 from "../../assets/security/reportIcon06.png";

const reports = [
  { no: "01", title: "Daily / Weekly / Monthly\n자동 보고서", icon: icon01 },
  { no: "02", title: "시간대별 차단현황\n분석 보고서", icon: icon02 },
  { no: "03", title: "사용자별 차단현황\n분석 보고서", icon: icon03 },
  { no: "04", title: "문서 종류별 차단현황\n분석 보고서\n(hwp, doc, ppt, pdf, xls 등)", icon: icon04 },
  { no: "05", title: "수신처(공격지)별 차단현황\n분석 보고서", icon: icon05 },
  { no: "06", title: "실행 프로세스별 차단현황\n분석 보고서", icon: icon06 },
];

const TrueEPReports = ({ styles }) => {
  return (
    <section className={styles.section}>
      <h2 className={styles.h2}>분석보고서</h2>
      <div className={styles.divider} />

      <div className={styles.grid}>
        {reports.map((r) => (
          <div className={styles.card} key={r.no}>
            <div className={styles.badge}>{r.no}</div>
            <div className={styles.cardBody}>
              <div className={styles.iconPlaceholder}>
                <img src={r.icon} alt={`${r.no} report icon`} className={styles.iconImg} draggable={false} />
              </div>
              <div className={styles.cardTitle}>
                {r.title.split("\n").map((line, idx) => (
                  <div key={idx}>{line}</div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default TrueEPReports